module.exports = __webpack_public_path__ + "img/DeNa.e44b7d6d.png";